import { render } from "./SidebarMenu.vue?vue&type=template&id=6e6da42e&ts=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=ts"
export * from "./SidebarMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__